/**
 * Utility class for number formatting using Intl.NumberFormat
 * Provides consistent number formatting across the application
 */
export class NumberFormat {
  /**
   * Formats a number with locale-specific thousands separators
   * @param amount - The number to format
   * @param locale - The locale to use for formatting (defaults to navigator.language)
   * @returns Formatted number string with thousands separators
   *
   * @example
   * NumberFormat.formatWithThousandsSeparator(1000) // "1,000"
   * NumberFormat.formatWithThousandsSeparator(1000000) // "1,000,000"
   */
  public static formatWithThousandsSeparator(amount?: number | string, locale?: string): string {
    if (typeof amount === 'undefined' || amount === null) {
      return '-';
    }

    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

    if (Number.isNaN(numericAmount)) {
      return amount.toString();
    }

    return new Intl.NumberFormat(locale || navigator.language, {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numericAmount);
  }
}
